'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _linkHandlersBefore = require('coact-utils/linkHandlersBefore');

var _linkHandlersBefore2 = _interopRequireDefault(_linkHandlersBefore);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  changeDocValue: _propTypes.func.isRequired
}), (0, _injectProps2.default)({
  onBlur: _propTypes.func.isRequired,
  onFocus: _propTypes.func.isRequired
}), (0, _getContext2.default)({
  emitter: _propTypes.object.isRequired
}), (0, _exposeHandlers2.default)((0, _linkHandlersBefore2.default)({
  onBlur: function onBlur(_ref) {
    var emitter = _ref.emitter,
        changeDocValue = _ref.changeDocValue;
    return function () {
      changeDocValue();
      emitter.removeListener('endEditing', changeDocValue);
    };
  },
  onFocus: function onFocus(_ref2) {
    var emitter = _ref2.emitter,
        changeDocValue = _ref2.changeDocValue;
    return function () {
      emitter.addListener('endEditing', changeDocValue);
    };
  }
})));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'controlDocValue');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/controlDocValue.js
// module id = 1732
// module chunks = 0